!function(root, factory) {

    factory(root, root.app, root.scrollMonitor);

}(this, function(root, app, scrollMonitor) {

    function init() {
        var $videos = $('video[data-video-play-in-view]');
        $videos.each(function(index, video) {
            createVideoMonitor(video);
        });
    }

    function createVideoMonitor(video) {
        var config = createScrollMonitorConfig(video, $(video).data());
        var monitor = scrollMonitor.create(video, config);
        monitor.enterViewport(config.enterViewportHandler);
        return monitor;
    }

    function createScrollMonitorConfig(video, videoData) {

        // Create handler for when video enters viewport.
        // Optionally, wrap with 'once' util if only should
        // be called once.
        var enterViewportHandler = function() { video.play(); };
        enterViewportHandler = videoData['videoPlayInViewOnce']
            ? app.util.once(enterViewportHandler)
            : enterViewportHandler;

        // Calculate scroll threshold offsets to determine
        // when handler is called.
        var topOffset = -parseFloat(videoData['videoPlayInViewTopOffsetRatio']) * getVideoHeight(video);

        return {
            enterViewportHandler: enterViewportHandler,
            top: topOffset
        };
    }

    function getVideoHeight(video) {
        // TODO: Get actual video height.
        // This is a hack that uses parent element's height instead
        return $(video).parent().get(0).offsetHeight;
    }

    app.extend({
        videoPlayInView: {
            init: init,
            createVideoMonitor: createVideoMonitor
        }
    });

    return app.videoPlayInView;
});
